import { render, staticRenderFns } from "./FUniswapTransactionList.vue?vue&type=template&id=1c1cf00c&"
import script from "./FUniswapTransactionList.vue?vue&type=script&lang=js&"
export * from "./FUniswapTransactionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports